module.exports = __webpack_public_path__ + "static/media/repContentIconAlt.405db855.svg";